import messageIdMapping from "../../IdMappings/MessageIdMapping.ts";
import {MessageNode} from "../../messageObject/MessageNode.ts";
import {reconcileChatDag} from "../../messageObject/reconcileChatDag.ts";
import {getIdToken} from "../../misc/miscUtils.ts";
import {URL_BASE} from "../../../Globals.ts";

export const getMessagesForChatId = async (user: any, chatId: string) => {
    if (!user) return;

    const token = await getIdToken(user);
    const url = `${URL_BASE}/api/loadChat`;

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ conversationId: chatId })
    });

    if (response.ok) {
        return await response.json()
    } else {
        console.error(`Failed to fetch messages for ${chatId}: ${response.statusText}`);
    }
}

export const getAllChats = async (user: any, setDynamicStateObj: any) => {
    try {
        if (!user) return;

        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/getAllChats`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (response.ok) {
            const responseData = await response.json();

            const parsedChatHistory = responseData.map((chat: any) => ({
                id: chat.chatId,
                name: chat.chatName,
                firstAccessedDate: chat.firstAccessedDate,
                lastAccessedDate: chat.lastAccessedDate,
                lastAccessedTimestamp: chat.lastAccessedTimestamp,
                isFavorite: chat.isFavorite || false
            }));
            setDynamicStateObj({chatHistory: parsedChatHistory});
        } else {
            console.error(`Failed to fetch chat history: ${response.statusText}`);
        }
    } catch (error) {
        console.error(`Error fetching chat history: ${error}`);
    }
};

export const loadChat = async (user: any, chatId: string, messagesSequenceRef: any, currentMessageRef: any, messagesRef: any, setMessages: any, updateImportantMessageIds: any, setDynamicStateObj: any, resetStateHelper: any) => {
    try {
        if (!user) return;

        setDynamicStateObj({visiblePopup: "loadingChatDots"});

        await resetStateHelper();

        const { messagesSequence, messages, importantMessageIds } = await getMessagesForChatId(user, chatId);
        if (!messagesSequence || !messages) {
            setDynamicStateObj({visiblePopup: null});
            throw new Error('Did not receive messagesSequence or messages');
        }

        setDynamicStateObj({conversationId: chatId});
        for (let i = 0; i < messages.length; i++) {
            const { id, childNum, message, children, parent, metadata } = messages[i].message;
            messageIdMapping[id] = new MessageNode(id, childNum, message, children, parent, metadata);
        }

        const reconciledChat = reconcileChatDag(messagesSequence, messageIdMapping);
        messagesRef.current = reconciledChat.rootNode;
        messagesSequenceRef.current = reconciledChat.messagesSequence;

        currentMessageRef.current = messagesRef.current;
        for (let i = 0; i < messagesSequenceRef.current.length; i++) {
            const nextChildIdx = messagesSequenceRef.current[i];
            const nextChildId = currentMessageRef.current.children[nextChildIdx];
            currentMessageRef.current = messageIdMapping[nextChildId];
        }

        importantMessageIds.map((messageId: string) => {
            updateImportantMessageIds(messageId, "add");
        });

        setMessages(messagesRef.current);
        setDynamicStateObj({scrollToBottom: true});
    } catch (error) {
        console.error(`Error fetching messages for ${chatId}: ${error}`);
        setDynamicStateObj({visiblePopup: "error", errorPopupMessage: "Error loading chat due to corrupted data..."});
    }

    setDynamicStateObj({visiblePopup: null});
};
